'use client';

import React, { forwardRef } from 'react';

interface NumberInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  className?: string;
  labelClassName?: string;
  prefix?: string;
  suffix?: string;
  containerClassName?: string;
}

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ 
    label, 
    error, 
    className = '', 
    labelClassName = '', 
    prefix,
    suffix,
    containerClassName = '',
    ...props 
  }, ref) => {
    return (
      <div className={`w-full font-sans font-normal ${containerClassName}`}>
        {label && (
          <label className={`block text-sm font-medium text-gray-800 mb-2 ${labelClassName}`}>
            {label}
          </label>
        )}
        <div className="relative flex items-center">
          {prefix && (
            <span className="text-base text-gray-600 font-normal mr-3">
              {prefix}
            </span>
          )}
          <div className="flex flex-col items-end flex-1">
            <input
              ref={ref}
              type="number"
              className={`
                w-full text-left outline-none text-base appearance-none bg-gray-50 rounded-lg px-4 py-2 
                transition border focus:ring-2
                ${error 
                  ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
                  : 'border-transparent focus:border-gray-400 focus:ring-blue-500'
                }
                ${className}
              `}
              step="0.01"
              min="0"
              {...props}
            />
            {error && (
              <p className="text-xs text-red-600 mt-1 text-right w-full">
                {error}
              </p>
            )}
          </div>
          {suffix && (
            <span className="text-base text-gray-600 font-normal ml-3">
              {suffix}
            </span>
          )}
        </div>
      </div>
    );
  }
);

NumberInput.displayName = 'NumberInput';

export default NumberInput;